// Constants and configuration for Playground component

// Environment detection function
export const getEnvironment = () => {
  try {
    if (typeof window === 'undefined' || !window.location) {
      return 'production';
    }

    const host = window.location.hostname;

    // Check backend URL from environment variables
    const borqsUrl = process.env.REACT_APP_BORQS_URL;

    if (borqsUrl) {
      if (borqsUrl.includes('stg.visist.ai') || borqsUrl.includes('staging')) {
        return 'staging';
      }
      if (borqsUrl.includes('poc.visist.ai') || borqsUrl.includes('poc')) {
        return 'poc';
      }
    }

    // Fallback to frontend hostname detection
    if (/poc/i.test(host)) {
      return 'poc';
    }
    if (/(staging|stage|stg)/i.test(host)) {
      return 'staging';
    }

    return 'production'; // fallback
  } catch (error) {
    return 'production';
  }
};

// Environment-specific post IDs
export const POST_IDS = {
  poc: {
    video1: '68b91ed3877a1c20be059978',
    video3: '68b91efc877a1c20be0599d4',
    video5: '68b91f1e877a1c20be059a32',
    video11: '68b91f39877a1c20be059a92'
  },
  staging: {
    video1: '68b6d9bea991d0c9ea12cbea',
    video3: '68b6d996a991d0c9ea12cbd0',
    video5: '68b6d9fea991d0c9ea12cc1e',
    video11: '68b6d9e0a991d0c9ea12cc04'
  },
  production: {
    video1: '68b91ed3877a1c20be059978', // fallback to poc IDs
    video3: '68b91efc877a1c20be0599d4',
    video5: '68b91f1e877a1c20be059a32',
    video11: '68b91f39877a1c20be059a92'
  }
};

// Get current environment and corresponding post IDs
const currentEnv = getEnvironment();
const currentPostIds = POST_IDS[currentEnv];

export const PREDEFINED_QUESTIONS = [
  'What is the average rally duration?',
  /*'Show me rally intensity over time'*/,
  'Which was the longest rally',
  'What is the win percentage in each phase?',
  'Which was the shortest rally',
  'Which player won the match?',
  'Which player lost the match?',
  'Distance covered by a player',
  'Best and worst rallies',
  'Show me cumulative stats'
];

// Video options - matching the existing folder structure
export const VIDEO_OPTIONS = [
  {
    value: 'video1',
    label: 'Video 1',
    videoPath: '/playground/video1/video/video1.mp4',
    basePath: '/playground/video1/',
    summaryPath: '/playground/video1/summary/video1.json',
    coordinatesPath: '/playground/video1/coordinates/video1_rally.csv',
    hitsPath: '/playground/video1/coordinates/video1_hits.csv',
    // Environment-specific post ID
    postId: currentPostIds.video1
  },
  {
    value: 'video3',
    label: 'Video 3',
    videoPath: '/playground/video3/video/video3.mp4',
    basePath: '/playground/video3/',
    summaryPath: '/playground/video3/summary/video3.json',
    coordinatesPath: '/playground/video3/coordinates/video3_rally.csv',
    hitsPath: '/playground/video3/coordinates/video3_hits.csv',
    // Environment-specific post ID
    postId: currentPostIds.video3
  },
  {
    value: 'video5',
    label: 'Video 5',
    videoPath: '/playground/video5/video/video5.mp4',
    basePath: '/playground/video5/',
    summaryPath: '/playground/video5/summary/video5.json',
    coordinatesPath: '/playground/video5/coordinates/video5_rally.csv',
    hitsPath: '/playground/video5/coordinates/video5_hits.csv',
    // Environment-specific post ID
    postId: currentPostIds.video5
  },
  {
    value: 'video11',
    label: 'Video 11',
    videoPath: '/playground/video11/video/video11.mp4',
    basePath: '/playground/video11/',
    summaryPath: '/playground/video11/summary/video11.json',
    coordinatesPath: '/playground/video11/coordinates/video11_rally.csv',
    hitsPath: '/playground/video11/coordinates/video11_hits.csv',
    // Environment-specific post ID
    postId: currentPostIds.video11
  },

  // Add more videos following the same structure
  // {
  //   value: 'videoX',
  //   label: 'Match X',
  //   videoPath: '/playground/videoX/video.mp4',
  //   basePath: '/playground/videoX/'
  // }
];

// Fallback dummy analytics and simple BarChart placeholder
export const DUMMY_ANALYTICS = {
  fastestSmash: '-',
  avgDuration: '-',
  shotAccuracy: '-',
  reactionTime: '-',
  rallyIntensity: [],
  winPercent: { initial: 0, mid: 0, final: 0 },
};
